<template>
     <header id="top" class="flex flex_r temp_wrap">
          <div class="logo">
               <img src="@/assets/logo.svg" alt="" />
          </div>
          <h3>@GrizzliesNFT</h3>
     </header>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
header {
     padding: 2.5rem 0px;
     cursor: pointer;
     h3 {
          padding: 15px 2rem;
          border-radius: 1rem;
          background: #131314;
          font-size: 1.3em;
          @include media('<=tablet') {
               font-size: 1em;
          }
     }
}
</style>
